<template>
  <div class="language-box">
    <el-tooltip content="练习试卷输入法下拉框内容仅供演示所用，如需使用报名简章中提及的考试输入法，请根据实际需要自行安装。" placement="top-start">
    <el-select size="small" v-model="value"
               placeholder="请选择"
               class="select">
      <el-option v-for="(item,index) in options"
                 :key="index"
                 :label="item"
                 :value="item">
      </el-option>
    </el-select>
    </el-tooltip>
  </div>
</template>
<script>
export default {
  name: 'LanguageBox',
  data() {
    return {
      options: [
        '微软拼音输入法（全拼）',
        '谷歌拼音输入法（全拼）',
        '搜狗拼音输入法（全拼）',
        '极品五笔输入法',
        '搜狗五笔输入法',
        '微软新仓颉输入法',
        '速成输入法',
        '新注音输入法',
      ],
      value: '微软拼音输入法（全拼）',
    }
  },
}
</script>
<style lang="scss" scoped>
.language-box {
  position: absolute;
  right: 15px;
  top: 50%;
  margin-top: -15px;

  .select {
    width: 181px;
  }
}
</style>
<style lang="scss">
.language-box {
  .el-input__inner {
    border-radius: 50px !important;
    border: 1px solid #447dff !important;
    color: #447dff !important;
  }

  .el-select .el-input .el-select__caret {
    color: #447dff !important;
  }
}
.language-box::before{
  content: "练习试卷输入法下拉框内容仅供演示所用，如需使用报名简章中提及的考试输入法，请根据实际需要自行安装。";
  padding: 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
  position: absolute;
  right: 0;
  top: -2rem;
  font-size: 14px;
  opacity: 0;
  transition: opacity .15s linear;
}
</style>
